// extracted by mini-css-extract-plugin
export default {"header_text":"privacy_policy_header_text__1rbEG","sub_text":"privacy_policy_sub_text__DgoQL"};